import { Event } from '@process-advisor/process-miner/api/events';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export const updateDataTransformation = ({ eventEmitter }: ApiMethodBase) => {
    eventEmitter.emit(Event.updateDataTransformation);
};
